export const validationConstants = {
  invalidType: 'INVALID_TYPE',
  required: 'REQUIRED',
  maxLength: 'MAX_LENGTH',
  minLength: 'MIN_LENGTH',
  minValue: 'MIN_VALUE',
  maxValue: 'MAX_VALUE',
  invalid: 'INVALID',
  passwordWeak: 'PASSWORD_WEAK',
  oneOf: 'ONE_OF'
};

export const ErrorMessages = {
  SaveAndFinishLater: "Failed to save the application!!!",
  Submit: "Failed to submit the application!!!",
  Withdraw: "Failed to withdraw the application!!!",
  ParseSessionStorage: "Failed to parse sessionStorage data:"
}